import React from "react";
import PropTypes from "prop-types";

import copy from "utils/clipboard";
import CopyConfirmationTooltip from "cards/components/CopyConfirmationTooltip";
import Icon from "components/Library/Icon";
import NoStyleButton from "components/Library/NoStyleButton/NoStyleButton";

import { COPY_LINK } from "config/constants";
import styles from "./CopyLinkButton.css";

export default class CopyLinkButton extends React.Component {
  constructor() {
    super();
    this.state = { clipboardConfirmOpen: false };
    this.copyPermalink = this._copyPermalink.bind(this);
  }

  _copyPermalink(e) {
    e.preventDefault();
    copy(this.props.permalink);
    this.setState({ clipboardConfirmOpen: true });
    setTimeout(() => {
      this.setState({ clipboardConfirmOpen: false });
    }, 1000);
  }

  render() {
    return (
      <>
        <CopyConfirmationTooltip open={this.state.clipboardConfirmOpen} />
        <NoStyleButton
          ariaLabel={COPY_LINK.DESCRIPTION}
          onClick={this.copyPermalink}
          className="gtm-copy-link"
        >
          <Icon
            name={COPY_LINK.NAME}
            path="img"
            description={COPY_LINK.DESCRIPTION}
            className={styles.icon}
          />
        </NoStyleButton>
      </>
    );
  }
}

CopyLinkButton.propTypes = {
  permalink: PropTypes.string.isRequired,
};
